<div class="container-fluid" *ngIf="message.active">
    <div class="alert alert-{{ message.color }}">
        <a href="https://status.qloc.de" target="_blank">{{ message.text }}</a>
    </div>
</div>